/**
 * @class Oskari.mapframework.bundle.search.request.SearchResultActionRequestHandler
 */
Oskari.clazz.define('Oskari.mapframework.bundle.search.request.SearchResultActionRequestHandler',
/**
 * @method create called automatically on construction
 * @static
 * @param {Oskari.Sandbox} sandbox
 *          reference to application sandbox
 * @param {Oskari.mapframework.bundle.search.Flyout} search
 *          reference to search flyout
 */
function (sandbox, search) {
  this.sandbox = sandbox;
  this.search = search;
}, {
  /**
   * @method handleRequest
   * @param {Oskari.mapframework.core.Core} core
   *      reference to the application core (reference sandbox core.getSandbox())
   * @param {Oskari.mapframework.bundle.search.request.AddSearchResultActionRequest | Oskari.mapframework.bundle.search.request.RemoveSearchResultActionRequest} request
   *      request to handle
   */
  handleRequest: function handleRequest(core, request) {
    if (request.getName() === 'Search.AddSearchResultActionRequest') {
      this.search.addSearchResultAction({
        name: request.getLinkName(),
        callback: request.getCallback()
      });
    } else if (request.getName() === 'Search.RemoveSearchResultActionRequest') {
      this.search.removeSearchResultAction(request.getLinkName());
    }
  }
}, {
  /**
   * @property {String[]} protocol array of superclasses as {String}
   * @static
   */
  protocol: ['Oskari.mapframework.core.RequestHandler']
});